import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';
import { UIRouterGlobals } from '@uirouter/angularjs';

export const $uiRouterGlobalsToken = upgradeExternalNg1Dependency<UIRouterGlobals>('$uiRouterGlobals');
